import { z } from 'zod';
export const schemaEquipeReseau = z
  .object({
    nom: z.string().trim().min(3).max(120),
    membres: z.array(z.string().uuid()).min(1).max(30),
    active: z.boolean().default(true),
  })
  .refine((d) => new Set(d.membres).size === d.membres.length, {
    message: 'Un membre ne peut apparaître deux fois',
    path: ['membres'],
  });
export const schemaModificationEquipeReseau = schemaEquipeReseau.safeExtend({
  version: z.number().int().positive(),
  motif: z.string().trim().min(3).max(500),
});
